<template>
  <section class="section my-0">
    <div class="shape shape-style-2 bg-white">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>

    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-20">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-0"
            body-classes="p-0 bg-white"
            class="border-0 h-100"
          >
            <template>
              <div class="row no-gutters align-items-stretch">
                <!-- Left: Image -->
                <div class="col-md-6 d-flex">
                  <img
                    src="../../public/register-image.png"
                    alt="Register"
                    class="img-fluid w-100 object-fit-cover"
                  />
                </div>

                <!-- Right: Form -->
                <div
                  class="col-md-6 d-flex flex-column justify-content-center p-4"
                >
                  <div class="text-center text-muted mb-4">
                    <small>Sign up to Topup Box</small>
                  </div>

                  <form role="form">
                    <base-input
                      alternative
                      class="mb-3"
                      placeholder="Name"
                      addon-left-icon="ni ni-user-run"
                    />
                    <base-input
                      alternative
                      class="mb-3"
                      placeholder="Email"
                      addon-left-icon="ni ni-email-83"
                    />
                    <base-input
                      alternative
                      class="mb-3"
                      type="number"
                      placeholder="Phone number"
                      addon-left-icon="ni ni-book-bookmark"
                    />
                    <base-input
                      alternative
                      type="password"
                      placeholder="Password"
                      addon-left-icon="ni ni-lock-circle-open"
                    />
                    <base-input
                      alternative
                      type="password"
                      placeholder="Confirm Password"
                      addon-left-icon="ni ni-lock-circle-open"
                    />

                    <base-checkbox>
                      <span>
                        I agree with the <a href="#">Privacy Policy</a>
                      </span>
                    </base-checkbox>

                    <div class="text-center">
                      <base-button type="primary" class="my-4 w-100">
                        Create account
                      </base-button>
                    </div>
                  </form>

                  <p class="text-center mb-0">
                    Already have an account?
                    <router-link
                      to="/login"
                      class="text-primary font-weight-700"
                    >
                      Login
                    </router-link>
                  </p>
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>
